/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"
import { hot, setConfig } from "react-hot-loader"

import Header from "./header"
import "../assets/css/layout.scss"
import Footer from "./footer"
import "dayjs/locale/tr"
import "dayjs/locale/en"
import dayjs from "dayjs"
import { useI18next } from "gatsby-plugin-react-i18next"

setConfig({
  showReactDomPatchNotification: false,
})

const Layout = ({ children }) => {
  const { language } = useI18next()
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  if (language === "en") {
    dayjs.locale("en")
  } else {
    dayjs.locale("tr")
  }

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
